import { Link, Stack, Typography } from '@mui/material';
import { FormSection } from 'Components';
import { FormSectionWrapper } from 'Components/FormSectionWrapper';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary } from 'Hooks';
import { CheckboxGroup } from 'Modules/CaseDetails/SecondSection/CheckboxGroup';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export const OtherBodies = () => {
  const {
    formState: { errors },
    setValue,
  } = useFormContext();

  const [formFillingAssistantOptions] = useAppSelector(
    ({
      generalContent: {
        generalContent: { formFillingAssistantOptions },
      },
    }) => [formFillingAssistantOptions]
  );

  const dictionary = useDictionary(Dictionary, DICTIONARY.REPRESENTATION);

  const formFieldNames = [
    'isAssistedByGoodHands',
    'isAssistedByIDF',
    'isAssistedByPolice',
    'isAssistedByPrisons',
    'none',
  ];

  const formFillingAssistant = useWatch({ name: 'formFillingAssistant' });

  useEffect(() => {
    if (errors.formFillingAssistant) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [errors.formFillingAssistant]);

  const formFillingAssistantHandler = (fieldName: string) => {
    const field = fieldName.split('formFillingAssistant.')[1];
    if (field === 'none' && !formFillingAssistant.none) {
      formFieldNames.forEach((fieldName: string) => {
        if (fieldName !== 'none' && formFillingAssistant[fieldName])
          setValue(`formFillingAssistant.${fieldName}`, false);
      });
    }
    if (field !== 'none' && formFillingAssistant.none)
      setValue(`formFillingAssistant.none`, false);
  };

  return (
    <FormSectionWrapper>
      <FormSection>
        <Stack
          sx={{
            bgcolor: '#F2F9FF',
            p: '16px',
          }}
        >
          <Typography>{dictionary.firstSectionIntro}</Typography>
          <Link
            sx={{ cursor: 'pointer' }}
            href='https://shikum.mod.gov.il/recognition/request/help'
            target='_blank'
          >
            {dictionary.firstSectionIntroLinkText}
          </Link>
        </Stack>
        <Stack gap='7px'>
          <Typography
            sx={{
              fontWeight: ' bold',
              color: errors.formFillingAssistant ? 'red' : undefined,
            }}
          >
            {dictionary.firstSectionIntroQ}
          </Typography>
          <CheckboxGroup
            name={`formFillingAssistant`}
            values={formFieldNames}
            options={formFillingAssistantOptions.map(({ id, value }) => ({
              value: id.toString(),
              label: value,
            }))}
            onClick={formFillingAssistantHandler}
          />
        </Stack>
      </FormSection>
    </FormSectionWrapper>
  );
};
